import React from "react";
import hand from '../../../assets/frothai/hand.svg';
import "../../css/Introduction.css";

export default function Introduction() {
  return (
    <section className="intro-section">
      <div className="intro-container">

        <div className="intro-left">
          <h1 className="intro-text">
            <span className="highlight">FrothAI</span>, TestOps revolutionary AI test case generation tool, is the perfect tool for creating seamless software testing. Do not waste time creating test cases manually; FrothAI will do it for you. Speed and efficiency, especially in difficult areas like testing, are what we at Froth TestOps are most proud of, thus making our tool one of the{" "}
            <span className="highlight">best ai tools for software testing</span> available today.
          </h1>
        </div>

        <div className="intro-right">
          <img src={hand} alt="hand" className="intro-img" />
        </div>

      </div>
    </section>
  );
}